module.exports = __webpack_public_path__ + "static/media/Gips.8f8d82a7.mp3";